import React from 'react';

import classNames from 'classnames/bind';
import style from './Title.scss';
const ctx = classNames.bind(style);

const Title = props => (
  <div className={ctx('title', 'inner', { 'inner--withBanner': true })}>
    {props.title}
  </div>
);

export default Title;
